import "react-datepicker/dist/react-datepicker.css";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import DashboardIcon from "../components/UI/DashboardIcon";
import { ServiceResponse, useGetAlerts } from "../hooks/useGetAlerts";
import { useContext, useEffect, useState } from "react";
import DateRangePicker from "../utils/DateRangePicker";
import DataTableHistory from "../components/History/DataTableHistory";
import { useHistoricalDataContext } from "../HistoricalDataContext";
import HistoricalEvolutionGraph from "../components/History/HistoricalEvolutionGraph";
import {
  GeneralServicePayload,
  GeneralServiceResponse,
  useGetGeneralData,
} from "../hooks/useGetGeneralData";
import Card from "../components/UI/Card";
import { MapComponent } from "../components/History/MapComponent";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import { TitleContext } from "../components/Context";
import { downloadCsv } from "../utils/helpers/csvExporter";

const HistoricalDataPage = () => {
  const { setTitle } = useContext(TitleContext);
  useEffect(() => {
    setTitle("Análisis Histórico");
  }, [setTitle]);
  const {
    alertStartDate,
    alertEndDate,
    generalStartDate,
    generalEndDate,
    selectedDate,
    filterGeneralDate,
    clearFilterGeneralDate,
  } = useHistoricalDataContext();
  useEffect(() => {
    handleAlertDateChange(alertStartDate, alertEndDate);
  }, [alertStartDate, alertEndDate]);

  useEffect(() => {
    handleGeneralDateChange(generalStartDate, generalEndDate);
  }, [generalStartDate, generalEndDate]);

  const [loadedData, setloadedData] = useState(false);

  const [loadingData, setLoadingData] = useState(true);

  const startLoading = () => setLoadingData(true);

  const stopLoading = () => setLoadingData(false);

  const hasLoadedData = () => setloadedData(true);

  const noLoadedData = () => setloadedData(false);

  const [formatAlertStartDate, setFormatAlertStartDate] = useState<string>("");

  const [formatAlertEndDate, setFormatAlertEndDate] = useState<string>("");

  const [formatGeneralStartDate, setFormatGeneralStartDate] =
    useState<string>("");

  const [formatGeneralEndDate, setFormatGeneralEndDate] = useState<string>("");

  const handleAlertDateChange = (alertStart: Date, alertEnd: Date) => {
    let encodedAlertStartDate = alertStart.toISOString();
    let encodedAlertEndDate = alertEnd.toISOString();
    setFormatAlertStartDate(encodedAlertStartDate);
    setFormatAlertEndDate(encodedAlertEndDate);
  };

  const handleGeneralDateChange = (generalStart: Date, generalEnd: Date) => {
    //console.log("General Start:", generalStart);
    //console.log("General End:", generalEnd);
    let encodedGeneralStartDate = generalStart.toISOString();
    let encodedGeneralEndDate = generalEnd.toISOString();
    setFormatGeneralStartDate(encodedGeneralStartDate);
    setFormatGeneralEndDate(encodedGeneralEndDate);
  };

  const transformBackendData = (
    generalDataResponse: GeneralServiceResponse
  ) => {
    interface MetricValue {
      value: number;
      recvTime: Date;
      timestamp?: Date;
    }
    const temperaturaData: MetricValue[] = [];
    const temperaturaNasaData: MetricValue[] = [];
    const conductividadData: MetricValue[] = [];
    const turbidezData: MetricValue[] = [];
    const salinidadData: MetricValue[] = [];
    const profundidadData: MetricValue[] = [];
    const phData: MetricValue[] = [];
    const orpData: MetricValue[] = [];
    const clorofilaData: MetricValue[] = [];
    const oxigenoDisueltoData: MetricValue[] = [];
    const oxigenoSaturacionData: MetricValue[] = [];
    const nitratoData: MetricValue[] = [];
    const amonioData: MetricValue[] = [];
    const cianobacteriasData: MetricValue[] = [];
    const nivelMarData: MetricValue[] = [];

    // Montevidata buoy specific metrics
    const temperaturaAguaData: MetricValue[] = [];
    const temperaturaAmbienteData: MetricValue[] = [];
    const presionAtmosfericaData: MetricValue[] = [];
    const precipitacionData: MetricValue[] = [];
    const velocidadVientoData: MetricValue[] = [];
    const direccionVientoData: MetricValue[] = [];
    const velocidadCorrienteData: MetricValue[] = [];
    const direccionCorrienteData: MetricValue[] = [];
    const olaAlturaSignificativaData: MetricValue[] = [];
    const olaAlturaMaximaData: MetricValue[] = [];
    const olaDireccionMediaData: MetricValue[] = [];
    const olaPeriodoPicoData: MetricValue[] = [];
    const bateriaPorcentajeData: MetricValue[] = [];
    const bateriaWhData: MetricValue[] = [];

    generalDataResponse.forEach((item) => {
      const {
        temperatura,
        temperatura_nasa,
        conductividad,
        turbidez,
        salinidad,
        profundidad,
        ph,
        orp,
        clorofila,
        oxigeno_disuelto,
        oxigeno_saturacion,
        nitrato,
        amonio,
        cianobacterias,
        temperatura_agua,
        temperatura_ambiente,
        presion_atmosferica,
        precipitacion,
        velocidad_viento,
        direccion_viento,
        velocidad_corriente,
        direccion_corriente,
        ola_altura_significativa,
        ola_altura_maxima,
        ola_direccion_media,
        ola_periodo_pico,
        bateria_porcentaje,
        bateria_wh,
        nivel_mar,
        recvTime,
        timestamp,
      } = item as any;
      if (temperatura !== undefined && temperatura !== null) temperaturaData.push({ value: temperatura, recvTime, timestamp });
      if (temperatura_nasa !== undefined && temperatura_nasa !== null) temperaturaNasaData.push({ value: temperatura_nasa, recvTime, timestamp });
      if (conductividad !== undefined && conductividad !== null) conductividadData.push({ value: conductividad, recvTime, timestamp });
      if (turbidez !== undefined && turbidez !== null) turbidezData.push({ value: turbidez, recvTime, timestamp });
      if (salinidad !== undefined && salinidad !== null) salinidadData.push({ value: salinidad, recvTime, timestamp });
      if (profundidad !== undefined && profundidad !== null) profundidadData.push({ value: profundidad, recvTime, timestamp });
      if (ph !== undefined && ph !== null) phData.push({ value: ph, recvTime, timestamp });
      if (orp !== undefined && orp !== null) orpData.push({ value: orp, recvTime, timestamp });
      if (clorofila !== undefined && clorofila !== null) clorofilaData.push({ value: clorofila, recvTime, timestamp });
      if (oxigeno_disuelto !== undefined && oxigeno_disuelto !== null) oxigenoDisueltoData.push({ value: oxigeno_disuelto, recvTime, timestamp });
      if (oxigeno_saturacion !== undefined && oxigeno_saturacion !== null) oxigenoSaturacionData.push({ value: oxigeno_saturacion, recvTime, timestamp });
      if (nitrato !== undefined && nitrato !== null) nitratoData.push({ value: nitrato, recvTime, timestamp });
      if (amonio !== undefined && amonio !== null) amonioData.push({ value: amonio, recvTime, timestamp });
      if (cianobacterias !== undefined && cianobacterias !== null) cianobacteriasData.push({ value: cianobacterias, recvTime, timestamp });
      if (temperatura_agua !== undefined && temperatura_agua !== null) temperaturaAguaData.push({ value: temperatura_agua, recvTime, timestamp });
      if (temperatura_ambiente !== undefined && temperatura_ambiente !== null) temperaturaAmbienteData.push({ value: temperatura_ambiente, recvTime, timestamp });
      if (presion_atmosferica !== undefined && presion_atmosferica !== null) presionAtmosfericaData.push({ value: presion_atmosferica, recvTime, timestamp });
      if (precipitacion !== undefined && precipitacion !== null) precipitacionData.push({ value: precipitacion, recvTime, timestamp });
      if (velocidad_viento !== undefined && velocidad_viento !== null) velocidadVientoData.push({ value: velocidad_viento, recvTime, timestamp });
      if (direccion_viento !== undefined && direccion_viento !== null) direccionVientoData.push({ value: direccion_viento, recvTime, timestamp });
      if (velocidad_corriente !== undefined && velocidad_corriente !== null) velocidadCorrienteData.push({ value: velocidad_corriente, recvTime, timestamp });
      if (direccion_corriente !== undefined && direccion_corriente !== null) direccionCorrienteData.push({ value: direccion_corriente, recvTime, timestamp });
      if (ola_altura_significativa !== undefined && ola_altura_significativa !== null) olaAlturaSignificativaData.push({ value: ola_altura_significativa, recvTime, timestamp });
      if (ola_altura_maxima !== undefined && ola_altura_maxima !== null) olaAlturaMaximaData.push({ value: ola_altura_maxima, recvTime, timestamp });
      if (ola_direccion_media !== undefined && ola_direccion_media !== null) olaDireccionMediaData.push({ value: ola_direccion_media, recvTime, timestamp });
      if (ola_periodo_pico !== undefined && ola_periodo_pico !== null) olaPeriodoPicoData.push({ value: ola_periodo_pico, recvTime, timestamp });
      if (bateria_porcentaje !== undefined && bateria_porcentaje !== null) bateriaPorcentajeData.push({ value: bateria_porcentaje, recvTime, timestamp });
      if (bateria_wh !== undefined && bateria_wh !== null) bateriaWhData.push({ value: bateria_wh, recvTime, timestamp });
      if (nivel_mar !== undefined && nivel_mar !== null) nivelMarData.push({ value: nivel_mar, recvTime, timestamp });
    });

    return {
      temperatura: temperaturaData,
      temperatura_nasa: temperaturaNasaData,
      conductividad: conductividadData,
      turbidez: turbidezData,
      salinidad: salinidadData,
      profundidad: profundidadData,
      ph: phData,
      orp: orpData,
      clorofila: clorofilaData,
      oxigeno_disuelto: oxigenoDisueltoData,
      oxigeno_saturacion: oxigenoSaturacionData,
      nitrato: nitratoData,
      amonio: amonioData,
      cianobacterias: cianobacteriasData,
      temperatura_agua: temperaturaAguaData,
      temperatura_ambiente: temperaturaAmbienteData,
      presion_atmosferica: presionAtmosfericaData,
      precipitacion: precipitacionData,
      velocidad_viento: velocidadVientoData,
      direccion_viento: direccionVientoData,
      velocidad_corriente: velocidadCorrienteData,
      direccion_corriente: direccionCorrienteData,
      ola_altura_significativa: olaAlturaSignificativaData,
      ola_altura_maxima: olaAlturaMaximaData,
      ola_direccion_media: olaDireccionMediaData,
      ola_periodo_pico: olaPeriodoPicoData,
      bateria_porcentaje: bateriaPorcentajeData,
      bateria_wh: bateriaWhData,
      nivel_mar: nivelMarData,
    };
  };

  const [context, setContext] = useState("sohma_la_paloma_mareografica_context");
  const contextLabels: Record<string, string> = {
    sohma_la_paloma_mareografica_context: "SOHMA LA PALOMA",
    sohma_punta_lobos_mareografica_context: "SOHMA PUNTA LOBOS",
    anp_muelle_fluvial_mareografo_context: "ANP MUELLE FLUVIAL",
    anp_colonia_mareografo_context: "ANP COLONIA",
    anp_fray_bentos_mareografo_context: "ANP FRAY BENTOS",
    anp_isla_de_flores_mareografo_context: "ANP ISLA DE FLORES",
    anp_la_paloma_mareografo_context: "ANP LA PALOMA",
    anp_nueva_palmira_mareografo_context: "ANP NUEVA PALMIRA",
    anp_paysandu_mareografo_context: "ANP PAYSANDÚ",
    montevideo_boya_context: "BOYA MONTEVIDEO",
    flowers_island_exo1_context: "ISLA DE FLORES EXO1",
    simcosta_rs4_context: "SIMCOSTA RS-4 (RIO GRANDE)",
    playa_mvd_pocitos_context: "PLAYA POCITOS",
    playa_mvd_buceo_context: "PLAYA BUCEO",
    playa_mvd_ramirez_context: "PLAYA RAMÍREZ",
    playa_mvd_carrasco_context: "PLAYA CARRASCO",
    playa_mvd_malvin_context: "PLAYA MALVÍN",
    playa_mvd_arroyo_carrasco_context: "ARROYO CARRASCO",
    playa_mvd_arroyo_molino_context: "ARROYO MOLINO",
    playa_mvd_de_los_ingleses_context: "PLAYA DE LOS INGLESES",
    playa_mvd_de_la_mulata_context: "PLAYA DE LA MULATA",
    playa_mvd_verde_context: "PLAYA VERDE",
    playa_mvd_honda_context: "PLAYA HONDA",
    playa_mvd_miramar_context: "PLAYA MIRAMAR",
    playa_mvd_brava_context: "PLAYA BRAVA",
    playa_mvd_de_los_cilindros_context: "PLAYA DE LOS CILINDROS",
    playa_mvd_pajas_blancas_context: "PLAYA PAJAS BLANCAS",
    playa_mvd_punta_yeguas_context: "PLAYA PUNTA YEGUAS",
    playa_mvd_santa_catalina_context: "PLAYA SANTA CATALINA",
    playa_mvd_la_colorada_context: "PLAYA LA COLORADA",
    playa_mvd_punta_espinillo_context: "PLAYA PUNTA ESPINILLO",
    playa_mvd_zabala_context: "PLAYA ZABALA",
    playa_mvd_del_cerro_context: "PLAYA DEL CERRO",
    playa_mvd_del_nacional_o_frigonal_context: "PLAYA DEL NACIONAL",
  };

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(pageSize + 1);


  const rows: ServiceResponse = useGetAlerts(
    context,
    formatAlertStartDate,
    formatAlertEndDate,
    page,
    pageSize,
    startLoading,
    stopLoading,
    hasLoadedData,
    noLoadedData
  );

  useEffect(() => {
    if (rows.length < pageSize) {
      setRowCount(page * pageSize + rows.length);
    } else {
      setRowCount((page + 1) * pageSize + 1);
    }
  }, [rows, page, pageSize]);

  const {
    data: generalDataResponse,
    reduced: isReduced,
  }: GeneralServicePayload = useGetGeneralData(
    context,
    formatGeneralStartDate,
    formatGeneralEndDate
  );

  const transformedDataSets = transformBackendData(generalDataResponse);
  const isExo1 = context === "flowers_island_exo1_context";
  const isBuoy = context === "montevideo_boya_context";
  const isSimcosta = context === "simcosta_rs4_context";
  const isMareografo = [
    "sohma_la_paloma_mareografica_context",
    "sohma_punta_lobos_mareografica_context",
    "anp_muelle_fluvial_mareografo_context",
    "anp_colonia_mareografo_context",
    "anp_fray_bentos_mareografo_context",
    "anp_isla_de_flores_mareografo_context",
    "anp_la_paloma_mareografo_context",
    "anp_nueva_palmira_mareografo_context",
    "anp_paysandu_mareografo_context",
  ].includes(context);
  const isPlaya = context.startsWith("playa_mvd_");
  const hasTempNasa = transformedDataSets.temperatura_nasa.length > 0;

  return (
    <Box
      component="section"
      sx={{
        pt: 3,
        pb: 4,
        px: { xs: 2, sm: 3, lg: 6 },
      }}
    >
      <Box sx={{ maxWidth: 1360, mx: "auto" }}>
        <Grid
          container
          rowSpacing={1}
          spacing={0}
          columns={12}
          justifyContent="flex-end"
          alignItems="center"
          sx={{ pt: 3, pb: 2 }}
        >
          <Grid item xs="auto">
            <span style={{ fontSize: "1rem", fontWeight: "normal", textTransform: "uppercase", color: "var(--mui-palette-text-primary)" }}>
              Seleccione un rango de fechas:
            </span>
            <Typography variant="caption" color="text.secondary" display="block">
              El filtrado se realiza por <strong>recvTime</strong> (momento de recepción), no por timestamp original de la muestra.
            </Typography>
          </Grid>
          <Grid item xs="auto" sx={{ ml: 1 }}>
            <DateRangePicker />
          </Grid>
        </Grid>


        <Card title={`ANÁLISIS HISTÓRICO - ${contextLabels[context]}`}>
          <Grid container spacing={0} columns={12} justifyContent="space-between" alignItems="center">
            <Grid item xs="auto">
              <DashboardIcon title="ANÁLISIS HISTÓRICO" />
            </Grid>
          </Grid>
          <Card title={"ALERTAS"}>
            <Grid container rowSpacing={1} spacing={2} justifyContent="center">
              <Grid item xs={6} paddingTop={"1rem"}>
                <MapComponent
                  onSelect={(c) => setContext(c)}
                  selectedContextId={context}
                />
              </Grid>
              <Grid item xs={6}>
                <DataTableHistory
                  title="ALERTAS"
                  rows={rows}
                  loading={loadingData}
                  loaded={loadedData}
                  page={page}
                  pageSize={pageSize}
                  rowCount={rowCount}
                  onPageChange={(newPage) => {
                    setPage(newPage);
                  }}
                  onPageSizeChange={(newSize) => {
                    setPageSize(newSize);
                    setPage(0);
                  }}
                />
              </Grid>
            </Grid>
          </Card>

          <Grid item xs={12}>
            <Grid container rowSpacing={1} spacing={0} columns={12}>
              <Grid item xs={12}>
                <Card
                  title={"EVOLUCIÓN DE PARÁMETROS"}
                  filters={filterGeneralDate}
                  filtersClear={clearFilterGeneralDate}
                >
                  {isSimcosta ? (
                    <>
                      <HistoricalEvolutionGraph
                        title="EVOLUCIÓN DE TEMPERATURA"
                        dataSet={
                          transformedDataSets.temperatura.length > 0
                            ? transformedDataSets.temperatura
                            : transformedDataSets.temperatura_agua
                        }
                        specificDate={selectedDate}
                        borderColor="#18265a"
                        backgroundColor="#18265a"
                      />
                      <HistoricalEvolutionGraph
                        title="EVOLUCIÓN DE SALINIDAD"
                        dataSet={transformedDataSets.salinidad}
                        specificDate={selectedDate}
                        borderColor="#2A9D8F"
                        backgroundColor="#2A9D8F"
                      />
                      <HistoricalEvolutionGraph
                        title="EVOLUCIÓN DE CLOROFILA"
                        dataSet={transformedDataSets.clorofila}
                        specificDate={selectedDate}
                        borderColor="#1E88E5"
                        backgroundColor="#1E88E5"
                      />
                      <HistoricalEvolutionGraph
                        title="EVOLUCIÓN DE TURBIDEZ"
                        dataSet={transformedDataSets.turbidez}
                        specificDate={selectedDate}
                        borderColor="#6D597A"
                        backgroundColor="#6D597A"
                      />
                      <HistoricalEvolutionGraph
                        title="EVOLUCIÓN DE ALTURA SIGNIFICATIVA DE OLA"
                        dataSet={transformedDataSets.ola_altura_significativa}
                        specificDate={selectedDate}
                        borderColor="#4361EE"
                        backgroundColor="#4361EE"
                      />
                      <HistoricalEvolutionGraph
                        title="EVOLUCIÓN DE ALTURA MÁXIMA DE OLA"
                        dataSet={transformedDataSets.ola_altura_maxima}
                        specificDate={selectedDate}
                        borderColor="#8E24AA"
                        backgroundColor="#8E24AA"
                      />
                      <HistoricalEvolutionGraph
                        title="EVOLUCIÓN DE PERÍODO DE PICO"
                        dataSet={transformedDataSets.ola_periodo_pico}
                        specificDate={selectedDate}
                        borderColor="#5E60CE"
                        backgroundColor="#5E60CE"
                      />
                    </>
                  ) : isMareografo ? (
                    <>
                      {transformedDataSets.temperatura_agua.length > 0 && (
                        <HistoricalEvolutionGraph
                          title="EVOLUCIÓN DE TEMPERATURA DEL AGUA"
                          dataSet={transformedDataSets.temperatura_agua}
                          specificDate={selectedDate}
                          borderColor="#FF7043"
                          backgroundColor="#FF7043"
                        />
                      )}
                      <HistoricalEvolutionGraph
                        title="EVOLUCIÓN DEL NIVEL DEL MAR"
                        dataSet={transformedDataSets.nivel_mar}
                        specificDate={selectedDate}
                        borderColor="#6C4AB6"
                        backgroundColor="#6C4AB6"
                      />
                    </>
                  ) : isPlaya ? (
                    <>
                      {transformedDataSets.temperatura_agua.length > 0 && (
                        <HistoricalEvolutionGraph
                          title="EVOLUCIÓN DE TEMPERATURA DEL AGUA"
                          dataSet={transformedDataSets.temperatura_agua}
                          specificDate={selectedDate}
                          borderColor="#5E60CE"
                          backgroundColor="#5E60CE"
                        />
                      )}
                      <HistoricalEvolutionGraph
                        title="EVOLUCIÓN DE SALINIDAD"
                        dataSet={transformedDataSets.salinidad}
                        specificDate={selectedDate}
                        borderColor="#40916C"
                        backgroundColor="#40916C"
                      />
                    </>
                  ) : (
                    <>
                      <HistoricalEvolutionGraph
                        title={isBuoy ? "EVOLUCIÓN DE TEMPERATURA DEL AGUA" : "EVOLUCIÓN DE TEMPERATURA"}
                        dataSet={isBuoy ? transformedDataSets.temperatura_agua : transformedDataSets.temperatura}
                        specificDate={selectedDate}
                        borderColor="#18265a"
                        backgroundColor="#18265a"
                      />
                      {isBuoy ? (
                        <>
                          <HistoricalEvolutionGraph
                            title="EVOLUCIÓN DE VELOCIDAD DEL VIENTO"
                            dataSet={transformedDataSets.velocidad_viento}
                            specificDate={selectedDate}
                            borderColor="#0B7285"
                            backgroundColor="#0B7285"
                          />
                          <HistoricalEvolutionGraph
                            title="EVOLUCIÓN DE ALTURA SIGNIFICATIVA DE OLA"
                            dataSet={transformedDataSets.ola_altura_significativa}
                            specificDate={selectedDate}
                            borderColor="#4361EE"
                            backgroundColor="#4361EE"
                          />
                          <HistoricalEvolutionGraph
                            title="EVOLUCIÓN DE PRESIÓN ATMOSFÉRICA"
                            dataSet={transformedDataSets.presion_atmosferica}
                            specificDate={selectedDate}
                            borderColor="#FF6F61"
                            backgroundColor="#FF6F61"
                          />
                          <HistoricalEvolutionGraph
                            title="EVOLUCIÓN DE PRECIPITACIÓN"
                            dataSet={transformedDataSets.precipitacion}
                            specificDate={selectedDate}
                            borderColor="#00897B"
                            backgroundColor="#00897B"
                          />
                          <HistoricalEvolutionGraph
                            title="EVOLUCIÓN DE TEMPERATURA AMBIENTE"
                            dataSet={transformedDataSets.temperatura_ambiente}
                            specificDate={selectedDate}
                            borderColor="#FB8C00"
                            backgroundColor="#FB8C00"
                          />
                          <HistoricalEvolutionGraph
                            title="EVOLUCIÓN DE VELOCIDAD DE CORRIENTE"
                            dataSet={transformedDataSets.velocidad_corriente}
                            specificDate={selectedDate}
                            borderColor="#1E88E5"
                            backgroundColor="#1E88E5"
                          />
                          <HistoricalEvolutionGraph
                            title="EVOLUCIÓN DE ALTURA MÁXIMA DE OLA"
                            dataSet={transformedDataSets.ola_altura_maxima}
                            specificDate={selectedDate}
                            borderColor="#8E24AA"
                            backgroundColor="#8E24AA"
                          />
                          <HistoricalEvolutionGraph
                            title="EVOLUCIÓN DE PERÍODO DE PICO"
                            dataSet={transformedDataSets.ola_periodo_pico}
                            specificDate={selectedDate}
                            borderColor="#5E60CE"
                            backgroundColor="#5E60CE"
                          />
                          <HistoricalEvolutionGraph
                            title="EVOLUCIÓN DE DIRECCIÓN DE VIENTO"
                            dataSet={transformedDataSets.direccion_viento}
                            specificDate={selectedDate}
                            borderColor="#6D597A"
                            backgroundColor="#6D597A"
                          />
                          <HistoricalEvolutionGraph
                            title="EVOLUCIÓN DE DIRECCIÓN DE CORRIENTE"
                            dataSet={transformedDataSets.direccion_corriente}
                            specificDate={selectedDate}
                            borderColor="#2A9D8F"
                            backgroundColor="#2A9D8F"
                          />
                          <HistoricalEvolutionGraph
                            title="EVOLUCIÓN DE DIRECCIÓN DE OLA"
                            dataSet={transformedDataSets.ola_direccion_media}
                            specificDate={selectedDate}
                            borderColor="#BC4749"
                            backgroundColor="#BC4749"
                          />
                          <HistoricalEvolutionGraph
                            title="EVOLUCIÓN DE BATERÍA (%)"
                            dataSet={transformedDataSets.bateria_porcentaje}
                            specificDate={selectedDate}
                            borderColor="#3949AB"
                            backgroundColor="#3949AB"
                          />
                        </>
                      ) : (
                        <>
                          <HistoricalEvolutionGraph
                            title="EVOLUCIÓN DE CONDUCTIVIDAD"
                            dataSet={transformedDataSets.conductividad}
                            specificDate={selectedDate}
                            borderColor="#C21292"
                            backgroundColor="#C21292"
                          />
                          {isExo1 && (
                            <>
                              <HistoricalEvolutionGraph
                                title="EVOLUCIÓN DE TURBIDEZ"
                                dataSet={transformedDataSets.turbidez}
                                specificDate={selectedDate}
                                borderColor="#6D597A"
                                backgroundColor="#6D597A"
                              />
                              <HistoricalEvolutionGraph
                                title="EVOLUCIÓN DE SALINIDAD"
                                dataSet={transformedDataSets.salinidad}
                                specificDate={selectedDate}
                                borderColor="#2A9D8F"
                                backgroundColor="#2A9D8F"
                              />
                              <HistoricalEvolutionGraph
                                title="EVOLUCIÓN DE PROFUNDIDAD"
                                dataSet={transformedDataSets.profundidad}
                                specificDate={selectedDate}
                                borderColor="#264653"
                                backgroundColor="#264653"
                              />
                              <HistoricalEvolutionGraph
                                title="EVOLUCIÓN DE pH"
                                dataSet={transformedDataSets.ph}
                                specificDate={selectedDate}
                                borderColor="#8AB17D"
                                backgroundColor="#8AB17D"
                              />
                              <HistoricalEvolutionGraph
                                title="EVOLUCIÓN DE ORP"
                                dataSet={transformedDataSets.orp}
                                specificDate={selectedDate}
                                borderColor="#E76F51"
                                backgroundColor="#E76F51"
                              />
                              <HistoricalEvolutionGraph
                                title="EVOLUCIÓN DE CLOROFILA"
                                dataSet={transformedDataSets.clorofila}
                                specificDate={selectedDate}
                                borderColor="#2A9D8F"
                                backgroundColor="#2A9D8F"
                              />
                              <HistoricalEvolutionGraph
                                title="EVOLUCIÓN DE OXÍGENO DISUELTO"
                                dataSet={transformedDataSets.oxigeno_disuelto}
                                specificDate={selectedDate}
                                borderColor="#1D3557"
                                backgroundColor="#1D3557"
                              />
                              <HistoricalEvolutionGraph
                                title="EVOLUCIÓN DE SATURACIÓN O2"
                                dataSet={transformedDataSets.oxigeno_saturacion}
                                specificDate={selectedDate}
                                borderColor="#457B9D"
                                backgroundColor="#457B9D"
                              />
                              <HistoricalEvolutionGraph
                                title="EVOLUCIÓN DE NITRATO"
                                dataSet={transformedDataSets.nitrato}
                                specificDate={selectedDate}
                                borderColor="#F4A261"
                                backgroundColor="#F4A261"
                              />
                              <HistoricalEvolutionGraph
                                title="EVOLUCIÓN DE AMONIO"
                                dataSet={transformedDataSets.amonio}
                                specificDate={selectedDate}
                                borderColor="#E9C46A"
                                backgroundColor="#E9C46A"
                              />
                              <HistoricalEvolutionGraph
                                title="EVOLUCIÓN DE CIANOBACTERIAS"
                                dataSet={transformedDataSets.cianobacterias}
                                specificDate={selectedDate}
                                borderColor="#009688"
                                backgroundColor="#009688"
                              />
                            </>
                          )}
                        </>
                        )}
                    </>
                  )}
                  {hasTempNasa && (
                    <HistoricalEvolutionGraph
                      title="EVOLUCIÓN DE TEMPERATURA DEL AGUA (NASA)"
                      dataSet={transformedDataSets.temperatura_nasa}
                      specificDate={selectedDate}
                      borderColor="#00ACC1"
                      backgroundColor="#00ACC1"
                    />
                  )}
                  <Tooltip
                    title={
                      isReduced
                        ? "Seleccione un intervalo de fechas más pequeño para descargar el CSV"
                        : ""
                    }
                    disableHoverListener={!isReduced}
                  >
                    <span>
                      <Button
                        sx={{
                          mt: 2,
                          color: isReduced ? "grey" : undefined,
                          alignSelf: "center",
                        }}
                        variant="outlined"
                        disabled={isReduced}
                        onClick={() =>
                          downloadCsv(
                            generalDataResponse,
                            formatGeneralStartDate,
                            formatGeneralEndDate
                          )
                        }
                      >
                        Descargar CSV
                      </Button>
                    </span>
                  </Tooltip>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Box>
    </Box>
  );
};

export default HistoricalDataPage;
